'use strict';

const jQuery = require('jquery');
const _ = require('lodash');

require('jquery-ui/ui/widgets/autocomplete');
const uniqId = require('uniq-id');
const {itemRenderer} = require('./../../../listTree');

const Container = require('./../../../../core/container');
const Translator = require('./../../../../core/translator');
const PageRepository = require('./../../../../bundles/page/repository/page');
const Autocomplete = require('./../../../autocomplete');
const Loader = require('./../../../loader');
const FormBuilder = require('./../../builder');
const Mediator = require('./../../../../core/mediator');
const RteConfig = require('./../../../../services/rte/config');

const deleteBtnTpl = require('./template/delete_button.hbs');
const disableBtnTpl = require('./template/disable_button.hbs');
const customUrlTpl = require('./template/custom_url.hbs');

let ElementClass = require('./../../elementClass');

const removeTags = function(element, removeStyles) {
    let textStr = element.replace(/<p[^>]*>/g, '');
    textStr = element.replace(/<br[^>]*>/g, '');
    textStr = textStr.replace(/<\/?p[^>]*>/g, '');
    if (false !== removeStyles) {
        textStr = textStr.replace(/<span[^>]*>/g, '');
        textStr = textStr.replace(/<\/?span[^>]*>/g, '');
    }

    return textStr;
};

FormBuilder.register('menu', function(config) {
    let self = new ElementClass(config);
    let $itemWrapper;
    let $customUrlInput = jQuery(customUrlTpl());
    let autocompleteConfig = {
        'autocomplete': {
            'source': function(request, response) {
                let $element = config.form.$.find(`.element_${config.name}`);
                let $input = $element.find('.input-autocomplete');

                $input.find('span:first').addClass('invisible');

                Loader.start($input);

                PageRepository.get({
                    'title': '%' + request.term + '%',
                    'page_uid': Container.get('page.uid'),
                }).done(function(data) {
                    $input.find('span:first').removeClass('invisible');

                    Loader.stop($input);
                    response(jQuery.map(data, function(item) {
                        return {
                            label: (item.lang ? `${item.lang.toUpperCase()} - ` : '') + `${item.title}`,
                            value: item.url,
                            id: item.id,
                            url: item.url,
                            target: item.target,
                            visible: item.visible,
                        };
                    }));
                });
            },
            'select': function(event, object) {
                jQuery(event.target).val('');

                $itemWrapper.nestable('add', {
                    'id': object.item.id,
                    'url': object.item.url,
                    'label': object.item.label.replace(/"/g, '\''),
                    'content': object.item.label,
                    'target': false,
                    'visible': true,
                });

                return false;
            },
        },
    };

    self.addCustomUrl = () => {
        let $inputId = $customUrlInput.find('input[name="customUrlId"]');
        let $inputLabel = $customUrlInput.find('input[name="customUrlLabel"]');
        let $inputLink = $customUrlInput.find('input[name="customUrlLink"]');
        let $inputTarget = $customUrlInput.find('input[name="elementTarget"]');
        let $inputVisible = $customUrlInput.find('input[name="elementVisible"]');
        let $addBtn = $customUrlInput.find('.add-custom-url');

        $inputLabel.on('click', function() {
            $inputLabel.addClass('d-none');
            self.createCkEditor($inputLabel.attr('placeholder'));
        });

        $addBtn.on('click', function() {
            let $ckInput = $customUrlInput.find('.cke_editable').html();
            let label = removeTags($ckInput);

            if (label !== 'label' && $inputLink.val()) {
                let item = {
                    label: label,
                    value: label,
                    id: $inputId.val(),
                    url: $inputLink.val(),
                    target: $inputTarget[0].checked,
                    visible: $inputVisible[0].checked,
                    labelstyles: removeTags($ckInput, false),
                };

                if ('' === $inputId.val()) {
                    item.id = (uniqId().substring(0, 5));
                    $itemWrapper.nestable('add', item);
                } else {
                    item.children = self.getItemById(item.id).children;
                    $itemWrapper.nestable('replace', item);
                }

                $customUrlInput.find('.cke_editable').remove();
                $inputId.val('');
                $inputLabel.removeClass('d-none');
                $inputLink.val('');
                $inputTarget.prop('checked', 'false');
                $inputVisible.prop('checked', 'true');

                $customUrlInput.find('.add-custom-url').html(Translator.translate('add'));
            }
        });
    };

    self.getItemById = function(id) {
        let found = null;
        let list = self.getData();
        let traverse = function(item, id) {
            if (null === found) {
                if (id === item.id) {
                    found = item;
                } else if (item.children) {
                    for (let j = 0; j < item.children.length; j++) {
                        traverse(item.children[j], id);
                    }
                }
            }
        };

        for(let i = 0; i < list.length; i++) {
            traverse(list[i], id);
        }

        return found;
    };

    self.buildItem = (item) => {
        return {
            'id': item.id,
            'url': item.url,
            'label': item.label.replace(/"/g, '\''),
            'labelstyles': item.labelstyles,
            'content': item.label,
            'children': item.children,
            'active': !item['is_clickable'] || false,
            'target': item.target,
            'visible': item.visible,
        };
    };

    self.createCkEditor = function(value) {
        let ckConfig = CKEDITOR.config;
        let $element = jQuery(`<div class="col">${value}</div>`);

        $customUrlInput.find('.cke_editable').remove();

        _.merge(CKEDITOR.config, RteConfig.buttons);
        $element.attr('contenteditable', true);

        /* eslint-disable */
        RteConfig.config.font_names = ckConfig.font_names;
        /* eslint-enable */

        let settings = RteConfig.config;
        Mediator.publish('before:rte:config', settings);

        CKEDITOR.disableAutoInline = true;
        CKEDITOR.inline($element.get(0), settings);
        CKEDITOR.once('currentInstance', function() {
            let instance = CKEDITOR.currentInstance;

            if (instance) {
                let $instance = jQuery('#cke_' + instance.ui.editor.name);

                $instance.addClass('cloud-cke');

                ckConfig.instance = instance;
            }
        });

        CKEDITOR.ui.on('ready', function(plugin) {
            jQuery('iframe.cke_panel_frame').contents().find('head').append(jQuery('#cloud-css').clone().get(0));
        });

        $customUrlInput.find('.input-wrapper').prepend($element);
    };

    self.buildGlobalDisableBtn = function() {
        $itemWrapper.find('> .dd-list').find('> li').each(function() {
            self.buildDisableBtn(jQuery(this));
        });
    };

    self.buildDisableBtn = function($item, active = false) {
        let $handle = $item.find('> .dd-handle');
        let $name = $handle.find('span');
        let $disableBtn = $item.find('input.disable');

        if ($item.find('> .dd-list').children().length > 0) {
            $name.addClass('parent-node');

            if (!$disableBtn.length) {
                let $btn = jQuery(disableBtnTpl({'active': active}));

                $btn.insertAfter($handle);
            }
        } else {
            $name.removeClass('parent-node');
            $disableBtn.remove();
        }
    };

    self.onDeleteBtnClick = function() {
        $itemWrapper.nestable('remove', jQuery(this).parents('li').data('id'));
    };

    self.onEditBtnClick = function() {
        let data = jQuery(this).parents('li').data();
        let $inputId = $customUrlInput.find('input[name="customUrlId"]');
        let $inputLink = $customUrlInput.find('input[name="customUrlLink"]');
        let $inputLabel = $customUrlInput.find('input[name="customUrlLabel"]');
        let $inputTarget = $customUrlInput.find('input[name="elementTarget"]');
        let $inputVisible = $customUrlInput.find('input[name="elementVisible"]');

        $inputLabel.addClass('d-none');
        self.createCkEditor(data.labelstyles ? data.labelstyles : data.label);
        $inputId.val(data.id);
        $inputLink.val(data.url);
        $inputTarget.prop('checked', data.target ? data.target : false);
        $inputVisible.prop('checked', data.visible ? data.visible : false);
        $customUrlInput.find('.add-custom-url').html(Translator.translate('edit'));
    };

    self.cancelEditUrl = function() {
        let $inputId = $customUrlInput.find('input[name="customUrlId"]');
        let $inputLabel = $customUrlInput.find('input[name="customUrlLabel"]');
        let $inputLink = $customUrlInput.find('input[name="customUrlLink"]');
        let $inputTarget = $customUrlInput.find('input[name="elementTarget"]');
        let $inputVisible = $customUrlInput.find('input[name="elementVisible"]');
        let $cancelBtn = $customUrlInput.find('.cancel-custom-url');

        $cancelBtn.on('click', function() {
            $customUrlInput.find('.cke_editable').remove();
            $inputLabel.removeClass('d-none');
            $inputId.val('');
            $inputLink.val('');
            $inputTarget.prop('checked', false);
            $inputVisible.prop('checked', true);
            $customUrlInput.find('.add-custom-url').html(Translator.translate('add'));
        });
    };

    self.buildOptions = (data) => {
        return {
            'json': data,
            'maxDepth': config.maxDepth || 2,
            'callback': self.buildGlobalDisableBtn,
            'itemRenderer': function(...args) {
                args[1] = removeTags(args[0]['data-label']);

                let $html = jQuery(itemRenderer(...args));
                let $deleteBtn = jQuery(deleteBtnTpl({
                    'customUrl': self.config.customUrl,
                }));

                $deleteBtn.insertAfter($html.find('> .dd-handle'));

                self.buildDisableBtn($html, args[4].active);

                return $html.get(0);
            },
        };
    };

    self.render = function($wrap) {
        let $autocompleteInput = Autocomplete.render(autocompleteConfig);

        $wrap.addClass('cloud-menu-parameters');

        $itemWrapper = jQuery('<div class="dd"></div>');

        $itemWrapper.nestable(self.buildOptions(config.value.map((item) => {
            if (item.children && item.children.length) {
                item.children = item.children.map((child) => {
                    child.children = child.children && child.children.length ? child.children.map(self.buildItem) : [];

                    return self.buildItem(child);
                });
            } else {
                item.children = [];
            }

            return self.buildItem(item);
        })));

        $wrap.append('<label class="cloud-label">' + Translator.translate('menu_form_explanation') + '</label>');
        $wrap.append($autocompleteInput);

        if (self.config.customUrl) {
            $wrap.append($customUrlInput);
            self.addCustomUrl();
        }

        $wrap.append('<div class="cloud-divider"></div>');
        $wrap.append($itemWrapper);

        $itemWrapper.on('click', '.remove', self.onDeleteBtnClick);

        if (self.config.customUrl) {
            $itemWrapper.on('click', '.edit', self.onEditBtnClick);
            self.cancelEditUrl();
        }

        self.buildGlobalDisableBtn();
    };

    self.getData = function() {
        const buildData = function(item) {
            let children = item.children && item.children.length ? item.children : null;
            let $item = $itemWrapper.find(`[data-id=${item.id}]`);

            return {
                'id': item.id,
                'url': item.url,
                'label': item.label.replace(/'/g, '\"'),
                'is_clickable': !$item.find('.disable').prop('checked'),
                'labelstyles': item.labelstyles ? item.labelstyles : null,
                'target': item.target ? item.target : false,
                'visible': item.visible ? item.visible : false,
                'children': children ? children.map(buildData) : children,
            };
        };

        return $itemWrapper.nestable('serialize').map(buildData);
    };

    return self;
});
